// a23cda39-74ba-4fa8-a19f-7826423f10c5

import { AxiosResponse } from 'axios';
import { AnswersState, answerStateSchema } from 'schemas/answerStateSchema';
import { notifySentry } from 'utils/error/notifySentry';
import { ZodError } from 'zod';
import { BusinessChoiceType, FlowChoiceType } from './types';

type ImportResult = {
  answers: AnswersState;
  error?: ZodError | undefined;
  toast?: { titleKey: string; descriptionKey: string } | undefined;
  redirect?: boolean;
};

// we verify type issue with zod, this allows us to also handle old configurations and retro compatibility
export const importSavedConfig = (
  configId: string,
  apiResponse: AxiosResponse
): ImportResult => {
  const answers = apiResponse.data as AnswersState;
  let toastData;

  // case of old configuration, that needs a redirect because too old
  if (!answers.addressDetails?.country) {
    notifySentry(`old configuration detected: ${configId}`);
    return {
      answers,
      redirect: true,
    };
  }

  // try parse using zod to validate the configuration
  const parsing = answerStateSchema.safeParse(answers);

  // case we have parsing errors
  if (parsing.error) {
    console.warn('IMPORT ISSUE >>', parsing.error.issues);
    notifySentry(`IMPORT ISSUE >> ${parsing.error.issues}`);
    let needToast = false;

    parsing.error.issues.forEach((issue) => {
      // case flowchoice is undefined, we update answers, do not show toast
      if (issue.path[0] === 'flowChoice' && issue.message === 'Required') {
        answers.flowChoice = answers.mapDetail
          ? FlowChoiceType.COMPLEX
          : FlowChoiceType.SIMPLE;
      }
      // case businessChoice is undefined, probably an old configuration that was done before business, we force b2c
      else if (
        issue.path[0] === 'businessChoice' &&
        issue.message === 'Required'
      ) {
        answers.businessChoice = BusinessChoiceType.B2C;
      }
      // other issues display an inconsistant configuration toast
      else {
        notifySentry(parsing.error);
        needToast = true;
      }
    });

    if (needToast)
      toastData = {
        titleKey: 'estimate.incorrectConfig.title',
        descriptionKey: 'estimate.incorrectConfig.description',
      };
  }

  return {
    answers,
    error: parsing.error,
    toast: toastData,
  };
};
